exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".join-page[data-v-52f9622e]{min-height:100vh;background:#f4f6fb}.topbar[data-v-52f9622e]{position:sticky;top:0;z-index:30;display:flex;align-items:center;justify-content:space-between;padding:12px 22px;background:#1c1c33;backdrop-filter:blur(8px);border-bottom:1px solid #e6e8f0}.brand[data-v-52f9622e]{display:flex;align-items:center;font-size:15px;font-weight:700;color:#22223d;letter-spacing:-.01em}.brand img[data-v-52f9622e]{display:block;max-height:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52f9622e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/Join.vue
// module id = 131
// module chunks = 0